module.exports = __webpack_public_path__ + "img/irish_coffee.776504d4.jpg";